module.exports = __webpack_public_path__ + "img/ide-probability.3142f249.svg";